import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Tabs, Modal } from 'antd';
import { css } from '@emotion/core';
import { when } from 'mobx';
import { SettingsFormHeader } from '../../common/SettingsFormHeader';
import ConnectDestination from './ConnectDestination';
import ConnectSource from './ConnectSource';
import ConnectThirdParty from './ConnectThirdParty';
import AccountTabPane from './AccountTabPane';
import IconSvg from '../../common/IconSvg';
import IconPng from '../../common/IconPng';
import { TopRow, ConnectionCard } from './styled';
import ENUMS from '../../../constants/enums';
import PopUpVideoLink from '../../common/PopUpVideoLink/PopUpVideoLink';
import { text2Medium } from '../../../constants/classes';
import { theme, fontSize } from '../../../constants';

const { confirm } = Modal;
const { TabPane } = Tabs;

@injectIntl
@inject('sessionStore')
@inject('enumsStore')
@inject('toastsStore')
@observer
class APIConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isConnecting: false,
      connectingTo: null,
      destinations: [],
    };
    this.breadcrumb = {
      name: props.intl.formatMessage({ id: 'settingsModal.connect' }),
      clickHandler: this.closeConnectionProcess,
    };
    this.reconnectDestinationAccount = this.reconnectDestinationAccount.bind(this);
  }

  componentDidMount() {
    this.props.updateBreadcrumbs(this.breadcrumb, true);
  }

  closeConnectionProcess = () => {
    this.setState({
      isConnecting: false,
      connectingTo: null,
      destinations: [],
    });
    this.props.updateBreadcrumbs(this.breadcrumb, true);
  };

  connectTarget = target => {
    this.setState({ isConnecting: true, connectingTo: target });
  };

  fetchDestinations = destinationTypeId => {
    this.props
      .fetchDestinationsOfType(destinationTypeId)
      .then(data => this.setState({ destinations: data }));
  };

  reconnectDestinationAccount(type) {
    this.fetchDestinations(type);
    when(
      () => this.state.destinations.length,
      () => {
        const [{ authorizationUrl }] = this.state.destinations;
        this.connectDestination(authorizationUrl);
      },
    );
  }

  showConfirmToDelete = (
    id,
    type,
    customMessageId = 'settingsModal.destinationDeleteWarning',
    currency,
  ) => {
    const { connectionManagement, intl } = this.props;
    confirm({
      content: intl.formatMessage({ id: customMessageId }),
      onOk() {
        connectionManagement.deleteSellerAccount(id, type, currency);
      },
      onCancel() {},
    });
  };

  showWarning = () => {
    const { intl, selectTab } = this.props;
    confirm({
      content: intl.formatMessage({ id: 'settingsModal.thirdpartyDeleteWarning' }),
      okText: 'Go to Subscription Settings',
      onOk() {
        selectTab(ENUMS.SETTINGS_TABS.SUBSCRIPTION);
      },
      onCancel() {},
    });
  };

  showUpdateProfile = () => {
    const { intl, selectTab } = this.props;
    confirm({
      content: intl.formatMessage({ id: 'settings.mandatoryNotFilled' }),
      okText: intl.formatMessage({ id: 'subscription.updateUserProfile' }),
      onOk() {
        selectTab(ENUMS.SETTINGS_TABS.USER_PROFILE);
      },
      onCancel() {},
    });
  };

  connectDestination = url => {
    window.open(url, '', 'height=750, width=750');
  };

  renderConnectionForm = () => {
    const {
      updateBreadcrumbs,
      connectionManagement,
      selectTab,
      sessionStore: { isNonApi },
    } = this.props;
    const { connectingTo, destinations } = this.state;

    switch (connectingTo) {
      case ENUMS.CONNECTION_MANAGEMENT.SOURCE:
        return (
          <ConnectSource
            updateBreadcrumbs={updateBreadcrumbs}
            closeForm={this.closeConnectionProcess}
          />
        );
      case ENUMS.CONNECTION_MANAGEMENT.DESTINATION:
        return (
          <ConnectDestination
            updateBreadcrumbs={updateBreadcrumbs}
            fetchDestinations={this.fetchDestinations}
            destinationTypeList={connectionManagement.getDestinationTypes}
            destinationList={destinations}
            connectDestination={this.connectDestination}
            closeForm={this.closeConnectionProcess}
            selectTab={selectTab}
            isNonApi={isNonApi}
          />
        );
      case ENUMS.CONNECTION_MANAGEMENT.THIRD_PARTY:
        return (
          <ConnectThirdParty
            connectPayoneerAccount={connectionManagement.connectPayoneerAccount}
            connectPaypalAccount={connectionManagement.connectPaypalAccount}
            connectStripeAccount={connectionManagement.connectStripeAccount}
            updateBreadcrumbs={updateBreadcrumbs}
            closeForm={this.closeConnectionProcess}
          />
        );
      default:
        return null;
    }
  };

  render() {
    const {
      connectionManagement,
      billingPaypalAccountId,
      isPaypalPreferred,
      billingPayoneerAccountId,
      isPayoneerPreferred,
      billingStripeAccountId,
      isStripePreferred,
      // intl,
      userDataIncomplete,
      // userProfile,
      sessionStore: { isNonApi },
    } = this.props;
    const { DESTINATION, THIRD_PARTY } = ENUMS.CONNECTION_MANAGEMENT;
    const defaultCurrency =
      connectionManagement.connectedAccounts.length > 0
        ? connectionManagement.connectedAccounts[0].marketplace
        : 'AZ_US';

    // dictionary to load the flag name in regards to the currency
    const loadFlag = { AZ_US: 'us', AZ_UK: 'gb', AZ_CA: 'ca',AZ_IT:'it',AZ_DE:'de', AZ_FR:'fr', AZ_ES:'es' };

    return (
      <div>
        {!this.state.isConnecting ? (
          <div>
            <SettingsFormHeader
              id="connection.connectedSites"
              defaultMessage="Connected Sites"
              marginTop="0"
            />
            <TopRow>
              {/* <ConnectionCard
                onClick={() => {
                  this.connectTarget(SOURCE);
                }}
              >
                <FormattedMessage
                  id="connection.connectSourceAccount"
                  defaultMessage="Connect Source Account"
                />
                <IconSvg type="plus-circle" />
              </ConnectionCard> */}
              {/* <Popover content={intl.formatMessage({ id: 'common.tryAgainLater' })} title="">
                <ConnectionCard
                  css={css`
                    cursor: not-allowed;
                    position: absolute;
                    width: 23.9%;
                    opacity: 0;
                  `}
                />
              </Popover> */}
              <ConnectionCard
                onClick={
                  userDataIncomplete
                    ? this.showUpdateProfile
                    : () => {
                        this.connectTarget(DESTINATION);
                      }
                }
              >
                <FormattedMessage
                  id="connection.connectDestinationAccount"
                  defaultMessage="Connect Destination Account"
                />
                <IconSvg type="plus-circle" />
              </ConnectionCard>
              <ConnectionCard
                onClick={() => {
                  this.connectTarget(THIRD_PARTY);
                }}
              >
                <FormattedMessage
                  id="connection.connectThirdPartyAccount"
                  defaultMessage="Connect Third Party Account"
                />
                <IconSvg type="plus-circle" />
              </ConnectionCard>
            </TopRow>
            <TopRow>
              <PopUpVideoLink
                message="How To Connect A Store:"
                videoUrl="https://vimeo.com/475869400/d194b9a8c6"
                extraCSS={`
                  margin-bottom: 20px;
                  text-decoration: underline;
                  &:hover {
                    text-decoration: underline;
                  }
                  ${text2Medium}
                  font-size: ${theme.fontSize.medium};
                `}
              />
              <TopRow>
                <a
                  css={css`
                    color: ${theme.colors.blueMed} !important;
                    text-decoration: underline;
                    font-size: ${fontSize.small};
                    &:hover {
                      color: ${theme.colors.blueLight} !important;
                    }
                  `}
                  href="/assets/sampleFiles/TripleMarsConnectionsGuide/TripleMarsConnectionsGuide.html"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  TripleMars Connections Guide
                </a>
              </TopRow>
            </TopRow>
            <SettingsFormHeader
              id="connection.connectedAccounts"
              defaultMessage="Connected Sites Accounts"
              css={css`
                margin-bottom: 0;
              `}
            />
            <Tabs defaultActiveKey={defaultCurrency}>
              {connectionManagement.connectedAccounts.map(
                ({ currency, source, destination, paypal, payoneer, stripe, marketplace }) => (
                  <TabPane
                    tab={<IconPng type={`flags/mini/${loadFlag[marketplace]}`} height={19} />}
                    key={marketplace}
                  >
                    <AccountTabPane
                      deleteAccount={(...args) =>
                        connectionManagement.deleteSellerAccount(...args, currency,marketplace)
                      }
                      editPassword={connectionManagement.editPassword}
                      connectGlobal={connectionManagement.connectGlobalShipping}
                      disconnectGlobal={connectionManagement.disconnectGlobalShipping}
                      showConfirmToDelete={(...args) => this.showConfirmToDelete(...args, currency)}
                      showWarning={this.showWarning}
                      sources={source}
                      destinations={destination}
                      thirdParties={paypal}
                      thirdPartiesPayoneer={payoneer}
                      thirdPartiesStripe={stripe}
                      billingPaypalAccountId={billingPaypalAccountId}
                      isPaypalPreferred={isPaypalPreferred}
                      billingPayoneerAccountId={billingPayoneerAccountId}
                      isPayoneerPreferred={isPayoneerPreferred}
                      billingStripeAccountId={billingStripeAccountId}
                      isStripePreferred={isStripePreferred}
                      currency={currency}
                      reconnectDestinationAccount={this.reconnectDestinationAccount}
                      isNonApi={isNonApi}
                    />
                  </TabPane>
                ),
              )}
            </Tabs>
          </div>
        ) : (
          this.renderConnectionForm()
        )}
      </div>
    );
  }
}

APIConnection.propTypes = {
  intl: PropTypes.object,
  connectionManagement: PropTypes.object,
  fetchDestinationsOfType: PropTypes.func,
  updateBreadcrumbs: PropTypes.func,
  selectTab: PropTypes.func,
  billingPaypalAccountId: PropTypes.string,
  userDataIncomplete: PropTypes.bool,
};

export default APIConnection;
